/* eslint-disable */
import es from 'vuetify/lib/locale/es';

export default {
  ...es,
  // NOMES IDIOMAS
  idioma: 'Idioma',
  // GERAL
  meusDados: 'Mis datos',
  sair: 'Salir',
  pesquisar: 'Buscar',
  kanban: 'Kanban',
  todosClientes: 'Todas las empresas',
  null: 'N/I',
  recusar: 'Recusar',
  aceitar: 'Aceptar',
  selecionados: 'Seleccionado',
  // NOVAS ATUALIZAÇÕES
  novasAtualizacoes: 'NUEVO!',
  novidade: 'Novedad',
  // FILTROS
  pesquisarBy: 'Buscar procesos por código o referencia',
  filtros: 'Filtros',
  download: 'Descargar',
  periodo: 'Periodo',
  tipoData: 'Tipo de fecha:',
  mostrarEncerrados: 'Mostrar procesos cerrados',
  encerrado: 'Closed',
  Abertura: 'Abertura',
  ETD: 'ETD',
  etd: 'ETD',
  ETA: 'ETA',
  eta: 'ETA',
  Embarque: 'Embarco',
  Chegada: 'Llegada',
  Originais: 'Originais',
  'Registro DI': 'Registro DI',
  removerFiltros: 'Eliminar filtros',
  filtrar: 'Filtro',
  ate: ' hasta ',
  warningFiltro: 'Seleccione un período válido y un tipo de búsqueda.',
  // MENU
  dashboard: 'Dashboard',
  tituloTooltipDashboard: 'Ver datos estadísticos sobre el rendimiento de los procesos de importación.',
  demandas: 'Demandas',
  abrirProcessos: 'Abrir procesos',
  novosProcessos: 'Nuevos procesos',
  tituloTooltipNovosProcessos: 'Inicia un nuevo proceso y espera su progreso para las etapas de importación. Edita los procesos haciendo doble clic en el campo deseado.',
  inicieUmNovoProcesso: 'Inicie un nuevo proceso y espere su progreso para las etapas de importación.',
  followUp: 'Follow-Up',
  inventario: 'Inventario',
  tituloTooltipEstoque: 'Tiene el propósito de mantener los niveles ideales de inventario, \nde acuerdo con los objetivos y demandas de la empresa.',
  armazem: 'Almacén',
  financeiro: 'Financiero',
  relatorios: 'Informes',
  tituloTooltipRelatorios:
    'Programa el envío de informes al correo electrónico sobre \ntu proceso y mantente al tanto de las actualizaciones que ocurren.',
  relatorio: 'Informe',
  nomeRelatorio: 'Nombre del Informe',
  documentos: 'Documentos',
  base: 'Base',
  usuarios: 'Usuarios',
  tituloTooltipUsuarios: 'Registra usuarios para poder compartir datos.',
  selecione: 'Wählen',
  selecioneTipo: 'Seleccione un tipo de usuario',
  claro: 'Claro',
  escuro: 'Oscuro',
  direitosReservados: 'Todos los derechos reservados',
  versao: 'Versión',
  termosCondicoes: 'Términos y condiciones',
  politicasPrivacidade: 'Políticas de privacidad',
  // ROLES
  ADMINISTRADOR: 'ADMINISTRADOR',
  ANALISTA: 'ANALISTA',
  CLIENTE: 'CLIENTE',
  CLIENTE_GESTOR: 'GESTOR DE CLIENTE',
  'CLIENTE GESTOR': 'GESTOR DE CLIENTE',
  CLIENTE_CONSULTOR: 'CLIENTE CONSULTOR',
  'CLIENTE CONSULTOR': 'CLIENTE CONSULTOR',
  // MODAL EXPORTAR EM EXCEL
  tituloModalExportar: 'Exportar en hoja de cálculo de Excel',
  planilhaBaixada: 'Hoja de calculo descargada',
  descricaoModalExportar: 'Selecciona las columnas que desea mostrar.',
  disponiveis: 'Disponible',
  selecionadas: 'Seleccionado',
  selecionarTodos: 'seleccionar todo',
  removerTodos: 'Eliminar todo',
  gerarArquivo: 'Generar archivo',
  Referência: 'Referencia',
  Processo: 'Proceso',
  'Status do Embarque': 'Estado del envío',
  'Unidade de Negócio': 'Unidad de Negocio',
  'Unidade de Medida': 'Unidade de Medida',
  Quantidade: 'Cantidad',
  Exportador: 'Exportador',
  Transportadora: 'Portador',
  Produto: 'Producto',
  'Conhecimento de Embarque': 'Conocimiento del embarque',
  'Número DI': 'Número DI',
  'Canal DI': 'Canal DI',
  Desembaraço: 'Desembaraço',
  Faturamento: 'Facturación',
  'Nº NF Entrada': 'Nº NF Entrada',
  Containers: 'Recipientes',
  tituloTooltipContainers: 'Esencial para garantizar el éxito de las operaciones de transporte marítimo de cargas, proporcionando eficiencia, seguridad y calidad a los procesos de importación.',
  'Emissão NF Entrada': 'Emisión NF Entrada',
  'Fechamento Operacional': 'Fechamento Operacional',
  'Exec. Carregamento': 'Cierre operativo',
  'Licenças de Importação': 'Licencias de importación',
  'Armador/Agente de carga': 'Armador/Agente de carga',
  // COLUNAS KANBAN
  tituloTooltipKanban:
    'Visualice el flujo de importación de manera práctica. Haga clic en la tarjeta para más detalles.',
  tooltipPreEmbarque: 'Fecha de apertura del procedimiento hasta la fecha de envío',
  tooltipTransito: 'Fecha de embarque hasta la llegada del buque al puerto',
  tooltipDesembaraco: 'Fecha de llegada de la carga al puerto hasta el despacho de la DI',
  tooltipCarregamento: 'Fecha de despacho hasta que se complete la carga',
  tooltipFaturamento: 'Fecha de finalización de la carga hasta el cierre operativo',
  preEmbarque: 'Pre-Envío',
  transito: 'En Tránsito',
  carregamento: 'Subir',
  Carregamento: 'Subir',
  carregamentoFaturamento: 'Carga/Facturación',
  carrFaturamento: 'Carga/Fact.',
  dataDoFaturamento: 'Fecha de facturación',
  solicitacao: 'Pedir',
  previsaoNaoInformada: 'Prev. emb no informado',
  dataCarregamento: 'Fecha carr.',
  dataFat: 'Data fact.',
  restam: 'Izquierda',
  dias: 'días',
  dia: 'día',
  Dias: 'Días',
  atrasado: 'Tarde',
  emDesembaraco: 'En despeje: ',
  emCarregamento: 'A cargo: ',
  emFaturamento: 'En la facturación: ',
  emFechamento: 'Para concluir: ',
  diaChegada: 'Día estimado de llegada',
  registro: 'Registro',
  nenhumItemFoi: 'Sin artículo',
  encontradoNaEtapa: 'encontrado en el paso',
  deFaturamento: 'Facturación',
  deCarregamento: 'carga',
  deDesembaraco: 'despeje',
  deTransito: 'tráfico',
  deEmbarque: 'pre-envío',
  Fechamento: 'Clausura',
  'Em Trânsito': 'En tránsito',
  'Em trânsito': 'En tránsito',
  'Pré-Embarque': 'Pre-Envío',
  // MODAL PROCESSO
  numeroContrato: 'Número de contrato',
  taxaCambial: 'Impuesto cambial',
  dataPagamento: 'Día de paga',
  valorReal: 'Valor en BRL',
  variacaoCambial: 'Variación de cambio',
  cambio: 'Cambio',
  tituloTooltipCambio: 'Sigue las modalidades de pago, fechas de vencimiento y tipos de negociaciones.',
  informacoes: 'Información',
  invoices: 'Invoices',
  contaCorrente: 'Cuenta corriente',
  maritima: 'Maritimo',
  rodoviaria: 'Autobuses',
  aerea: 'Antena',
  embarque: 'Embarco',
  informacoesGerais: 'Información General',
  tipoProcesso: 'Tipo do processo',
  unidadeNegocio: 'Unidad de negocio',
  referenciaInterna: 'Referencia interna',
  referenciaTrust: 'Referencia Trust',
  referenciaCliente: 'Referencia Cliente',
  'Referência Cliente': 'Referencia Cliente',
  'Referência Trust': 'Referencia Trust',
  cliente: 'Cliente',
  exportador: 'Exportador',
  produto: 'Producto',
  invoice: 'Invoice',
  cidadeEmbarque: 'Cidad de pre-envio',
  cidadeDestino: 'Cidad de destino',
  'CONTA E ORDEM': 'CUENTA Y PEDIDO',
  'CONTA E ORDEM DE TERCEIROS': 'CUENTA Y PEDIDO',
  'CONTA PRÓPRIA': 'CONTA PROPRIA',
  'CONTA PROPRIA': 'CONTA PROPRIA',
  'IMPORTAÇÃO POR ENCOMENDA': 'IMPORTACIÓN BAJO DEMANDA',
  transporteLogistica: 'Transporte y Logística',
  statusEmbarque: 'Estado de embarque',
  modal: 'Modal',
  tipoCarga: 'Tipo de carga',
  incoterm: 'INCOTERM',
  incoterms: 'Incoterms',
  conhecimento: 'Conocimiento',
  navioVeiculo: 'Barco/Vehículo',
  containers: 'Contenedores',
  container: 'Contenedor',
  Container: 'Contenedor',
  containerConsolidado: 'Contenedor consolidado',
  devolucaoContainer: 'Devolución de contenedor',
  pesoBruto: 'Peso Bruto(KG)',
  pesoLiquidoKG: 'Peso Neto(KG)',
  URFEntrada: 'URF Entrada/Chegada',
  freeTime: 'Free Time',
  freetime: 'Free Time',
  freteCollect: 'Frete collect',
  fretePrepaid: 'Frete prepaid',
  valorTotalFrete: 'Importe total del flete',
  moedaFrete: 'Moneda Flete',
  embalagemFrete: 'Embalaje',
  quantidadeEmbalagem: 'Ctd. Embalaje',
  datasPrevistas: 'Fechas previstas',
  previsaoEmbarque: 'Previsão de embarje',
  previsaoChegada: 'Pronóstico de llegada',
  datasConfirmadas: 'Fechas confirmadas',
  dataEmbarque: 'Fechas de salida',
  dataChegada: 'Fechas de chegada',
  datasLiberacoes: 'Fechas de llegada',
  dataLiberacaoSiscarga: 'Fecha de lanzamiento Siscarga',
  dataLiberacaoMapa: 'Fecha de liberación del mapa',
  liberacaoMinisterioAgricultadoPecuaria: 'Fecha de liberación del MAPA',
  ultimaMovimentacao: 'Última jugada',
  presencaCarga: 'Presencia de carga',
  licencasImportação: 'Licencias de importación',
  tituloTooltipLI: 'Sigue las licencias necesarias para la importación, con el objetivo de regular el comercio internacional y proteger la economía nacional.',
  numLi: 'Nº de LI',
  orgaoAnuente: 'Órgano anual',
  dataRegistro: 'Fecha de inscripción',
  dataStatus: 'Fecha de estado',
  dataValidade: 'Fecha de caducidad',
  statusLicenca: 'Estado de la licencia',
  'Status L.I': 'Estado de la licencia',
  declaracaoImportacao: 'Declaración de importación',
  numeroRegistro: 'Matrícula',
  dataDesembaraco: 'Fecha de despacho',
  canalParametrizacao: 'Canal de parametrización',
  parametrizacao: 'Parametrización',
  atualizacoes: 'Actualizaciones',
  ultimaAtualizacao: 'Última actualización',
  dataNaoInformada: 'Fecha no reportada',
  baixarTodos: 'Descargar todo',
  solicitacaoNumerario: 'Reclamación en efectivo',
  descricao: 'Descrição',
  dataSolicitacao: 'Fecha de la solicitud',
  'Data da solicitação': 'Fecha de la solicitud',
  acessar: 'Acceso',
  Acessar: 'Acceso',
  fechamentoProcesso: 'Cierre de procesos',
  visualizar: 'Visualizar',
  Visualizar: 'Visualizar',
  processo: 'Proceso',
  processoAberto: 'Tu proceso ha sido abierto con éxito.',
  data: 'Fecha',
  formacaoValorAduaneiro: 'Formación del valor en aduana',
  valorAduaneiroEstimado: 'Valor aduanero estimado',
  composicao: 'Composición',
  moeda: 'Moneda',
  Moeda: 'Moneda',
  valorNegociado: 'Valor negociado',
  valorBRL: 'Valor BRL',
  impostos: 'Impuestos',
  despesasNacionalizacao: 'Gastos de nacionalización',
  icmsIpiTransferencia: 'ICMS/IPI Transferencia',
  referencia: 'Referencia',
  codigoProcesso: 'Código de proceso',
  'II - IMPOSTO DE IMPORTAÇAO': 'IMPUESTO DE IMPORTACIÓN',
  naoInformado: 'No informado',
  semAtualizacoes: 'Sin actualizaciones',
  as: 'as',
  semDocumentos: 'No hay documentos disponibles',
  solicitar: 'Pedir',
  documento: 'Documento',
  dataEmissao: 'Fecha de emisión',
  numerario: 'Efectivo',
  total: 'Total',
  Total: 'Total',
  nenhumaInformacao: 'Sin información hasta la fecha',
  notasComplementares: 'Notas complementarias',
  notasFiscalEletronica: 'Factura electrónica',
  valorNota: 'Valor factura',
  numeroNota: 'Número da nota',
  codigoDocumento: 'Código del documento',
  totalBruto: 'Total bruto',
  totalLiquido: 'Total neto',
  despesa: 'Gasto',
  valorBruto: 'Valor bruto',
  valorLiquido: 'Valor neto',
  meioUtilizado: 'Medios de transporte utilizados',
  lclFcl: 'LCL (Carga Consolidada/Suelta), FCL (Contenedor)',
  tipoBL: 'Número B/L (Tarjeta de embarque)',
  recintoDesembaraco: 'Recinto de despacho de aduanas',
  unidadeReceitaFederal: 'Unidad de Ingresos Federales para el puerto de entrada',
  VERDE: 'VERDE',
  AMARELO: 'AMARILLO',
  VERMELHO: 'ROJO',
  CINZA: 'GRIS',
  invoicesProcesso: 'Invoices do processo',
  numeroInvoice: 'Número de invoice',
  itensInvoice: 'Artículos da invoice',
  item: 'Artículos',
  Item: 'Artículos',
  fabricante: 'Fabricante',
  Fabricante: 'Fabricante',
  NCM: 'NCM',
  quantidade: 'Cantidad',
  condicaoPagamento: 'Condiciones de pago',
  'Condição de pagamento': 'Condiciones de pago',
  unidadeMedida: 'Unidad de medida',
  'Unidade de medida': 'Unidad de medida',
  valorUnitario: 'Valor Unitario',
  'Valor Unitário': 'Valor Unitario',
  totalCredito: 'Crédito total',
  totalDebito: 'Deuda total',
  diferenca: 'Diferencia',
  origem: 'Origen',
  Origem: 'Origen',
  evento: 'Evento',
  Evento: 'Evento',
  credito: 'Crédito',
  Crédito: 'Crédito',
  debito: 'Débito',
  Débito: 'Débito',
  vencimento: 'Sueldo',
  Vencimento: 'Sueldo',
  complemento: 'Complemento',
  Complemento: 'Complemento',
  mapa: 'Mapa',
  notaFiscalEntrada: 'Factura introducida',
  ENCOMENDA: 'ORDEN',
  PROPRIO: 'POSEER',
  PRÓPRIO: 'POSEER',
  'ENCOMENDA PADRAO': 'ORDEN ESTÁNDAR',
  'ENCOMENDA PADRÃO': 'ORDEN ESTÁNDAR',
  'ENCOMENDA ESPECIAL': 'PEDIDO ESPECIAL',
  'Nº da LI': 'N° de LI',
  'Órgão anuente': 'Órgano anuent',
  'Data de registro': 'Fecha de inscripción',
  'Data de status': 'Fecha de estado',
  'Data de validade': 'fecha de caducidad',
  'Status da licença': 'Estado de la licencia',
  'SEM PARAMETRO': 'SIN PARAMETRO',
  // MAPA
  maritimo: 'Marítimo',
  rodoviario: 'Camino',
  todos: 'Todos',
  abrirProcesso: 'Proceso abierto',
  abrirProcessoNovaAba: 'Abrir proceso en una nueva pestaña',
  embarcacao: 'Buques',
  veiculos: 'Vehículos',
  portos: 'Puertos',
  armazemTaglog: 'Almacén TRUST',
  agrupamentos: 'Agrupaciones',
  trajetoPrevisto: 'Ruta prevista',
  trajetoPercorrido: 'Camino recorrido',
  cotacao: 'Cita',
  dolar: 'Dólar',
  euro: 'Euro',
  especialistaComex: 'Especialista en COMEX',
  email: 'E-mail',
  celularWhatsapp: 'WhatsApp',
  destino: 'Destino',
  navio: 'Navío',
  Navio: 'Navío',
  visualizarProcesso: 'Ver processo',
  porto: 'Puerto',
  numeroPassagens: 'Número de aprobación',
  CNPJ: 'CNPJ',
  localizacao: 'Ubicación',
  naviosAgrupados: 'Buques agrupados',
  portosAgrupados: 'Puertos agrupados',
  clientesAgrupados: 'Clientes agrupados',
  viagensAgrupados: 'Viajes en grupo',
  CTE: 'CTe nº',
  viagem: 'Viajar',
  atualizadoEm: 'Actualizado el:',
  por: 'por',
  status: 'Estado',
  remetente: 'Remitente',
  destinatario: 'Destinatario',
  destinatarios: 'Destinatarios',
  informacaodeCarga: 'Cargar información',
  valorCarga: 'Valor de carga',
  valorCargaAverbada: 'Valor de carga registrado',
  valorPrestado: 'valorProporcionado',
  valorRecebido: 'cantidadRecibida',
  // MODAL SELECIONAR CLIENTES
  selecionarClientes: 'Seleccionar empresas',
  // ABERTURA DE PROCESSO
  aberturaProcesso: 'Apertura del proceso',
  solicitarCancelamento: 'Solicitar la cancelación del proceso',
  solicitarAlteracao: 'Solicitar cambio',
  alteracoesEncaminhadas: 'Se han guardado sus cambios y se enviarán a nuestros especialistas para su revisión',
  jaPossuiAlteracao: 'Este proceso ya tiene una solicitud de cambio',
  aguardandoCancelamento: 'Esperando la cancelación del proceso',
  aguardandoAprovaoAlteracao: 'Esperando aprobación de cambio',
  solicitacaoAlteracaoPendente: 'Tiene una solicitud de cambio pendiente en este proceso',
  alteracoesFeitas: 'Cambios realizados por el cliente',
  aceitarSolicitacaoPendente: 'Aceptar cambios en el proceso',
  desejaAceitarAsAlteracoes: '¿Desea aceptar los cambios?',
  casoAceite: 'Si confirma, los datos de este proceso se modificarán',
  seVoceConfirmar: 'Si confirma esta solicitud, sobrescribirá la solicitud actualmente en espera',
  suaSolicitacaoDeCancelamento: 'Su solicitud de cancelación ha sido enviada a nuestros expertos',
  processoAtualizado: 'Su solicitud de proceso ha sido actualizada',
  emCancelamento: 'En cancelación',
  exibirColunas: 'Ver columnas',
  'Tipo Importação': 'Tipo de Importación',
  Finalidade: 'Propósito',
  modelosProntos: 'Modelos listos para usar',
  Empresa: 'Empresa',
  'Solicitado em': 'Solicitado en',
  solicitadoPor: 'Solicitado por',
  responsavel: 'Responsable',
  Ações: 'Acciones',
  responsaveisNaoVinculados: 'No hay tutores vinculados a tu empresa',
  registrosPorPagina: 'Archivo por página',
  registros: 'Archivo',
  resultados: 'Resultados',
  editar: 'Editar',
  editarItem: 'Editar elemento',
  remover: 'Eliminar',
  solicitarAbertura: 'Apertura del proceso de solicitud',
  itens: 'Artículos',
  Itens: 'Artículos',
  observacao: 'Observaciones',
  anexarArquivos: 'Adjuntar archivos',
  arquivosAnexados: 'Archivos adjuntos',
  adicionarArquivos: 'Agregar archivos',
  salvar: 'Salvar',
  tipoDocumento: 'Tipo de documento',
  escolherArquivo: 'Elegir archivo',
  unidadeComercializada: 'Un. de medida comercializada',
  carregando: 'Cargado',
  tooltipMercosul:
    'Nomenclatura común del Mercosur (código que ayuda a identificar los productos que circulan en Brasil, Argentina, Paraguay, Uruguay y otros países del Mercosur)',
  modificar: 'Modificar',
  // LISTAGEM DE PROCESSOS
  cadastrarProduto: 'Registrar producto',
  editarProduto: 'Editar producto',
  adicionarProduto: 'Añadir producto',
  adicionadoProduto: 'Producto añadido',
  produtoAdicionado: '¡Producto añadido! ¿Registrar producto?',
  indice: 'Índice',
  todosCamposObrigatorios: 'Todos los campos son obligatorios.',
  preenchaCamposObrigatorios: 'Por favor, complete todos los campos requeridos',
  confirmarRemoverLista: '¿Está seguro de que desea eliminar este producto de la lista?',
  cadastroFuturo: 'Puede registrarlo nuevamente en el futuro.',
  editarReferencia: 'Editar referencia',
  codigoCliente: 'Código del cliente',
  grupo: 'Grupo',
  fornecedor: 'Proveedor',
  produtor: 'Productor',
  Fornecedor: 'Proveedor',
  Produtor: 'Productor',
  produtorFabricante: 'Productor / Fabricante',
  codigoTrust: 'Código Trust',
  textoNCM:
    'Al registrarse, podrá utilizar este mismo producto en otras operaciones, al ingresar el NCM.',
  cadastrar: 'Registrar',
  Importador: 'Importador',
  // LISTAGEM DE PROCESSOS
  listagemProcessos: 'Listado de procesos',
  processosAfiliados: 'Seguimiento de Afiliados',
  tituloTooltipListagemProcessos:
    'Todos los procesos en lista, pudiendo filtrar \ny guardar en modelos para facilitar el uso.',
  modeloRelatorios: 'Plantillas de informe',
  relatorioSalvo: 'Informe se guardó con éxito.',
  relatorioAtualizado: 'Informe actualizado con éxito',
  relatorioSemDescricao: 'Un informe no se puede guardar sin una descripción',
  criarModeloRelatorio: 'Crear una nueva plantilla de informe',
  alterarModeloRelatorio: 'Actualizar plantilla de informe',
  digiteAqui: 'Entra aquí',
  digiteAquiNCM: 'Busque aquí NCM',
  selecioneColunas: 'Seleccione las columnas que desea mostrar',
  criarRelatorio: 'Crear informe',
  atualizarRelatorio: 'Informe de actualización',
  relatorioAplicado: 'Informe aplicado',
  listagem: 'Lista',
  deferimentoLi: 'Aprobación de LI',
  // INVENTARIO
  de: 'of',
  fraseEstoqueMiniRefpart1: 'El valor de referencia es el stock actual. Esto significa que si se marca la casilla, se establecerá el stock mínimo.',
  fraseEstoqueMiniRefpart2: '% de stock actual disponible',
  estoqueMinimoMensagemPorcentagemAviso: 'Al seleccionar el stock por porcentaje, debe estar entre 1 y 200.',
  valorPorPercentagemEstoque: 'Porcentaje mínimo de inventario (%) del actual',
  'Código do produto': 'Código de producto',
  'Nome do Produto': 'Nombre del producto',
  'Categoria do NCM': 'Categoría NCM',
  'Previsão no armazém': 'Previsión en almacén',
  estabelecimento: 'Establecimiento',
  descricaoGrupo: 'Descripción del Grupo',
  quantidadeAtual: 'Cantidad actual',
  situacao: 'Situación',
  descricaoEndereco: 'Descripción de la dirección',
  inventarioDescricao: 'Inventario del día anterior',
  descricaoProduto: 'descripción del producto',
  depositante: 'Depositor',
  tipoUnidade: 'Tipo de unidad',
  classe: 'clase',
  quantidadeEmpenhado: 'Cantidad prometida',
  quantidadeReserva: 'Cantidad de reserva',
  armazenadoEm: 'Guardado en',
  quantidadeProdutosEmTransito: 'Cantidad de productos en tránsito',
  quantidadeProdutosAtual: 'Cantidad actual de productos.',
  // ARMAZEM
  // RELATORIOS
  adicionar: 'Agregar',
  Habilitado: 'Calificado',
  Descrição: 'Descripción',
  desabilitado: 'Deshabilitado',
  'Dias da Semana': 'Días de la semana',
  Horário: 'Horario',
  'E-mails': 'E-mails',
  adicionarRelatorio: 'Crear informe',
  editarRelatorio: 'Editar informe',
  conteudoRelatorio: 'Contenido del informe',
  escolhaColunasFiltros: 'Elija las columnas o seleccione un filtro favorito',
  escolhaColunasFiltrosIntro1: 'Puede marcar un filtro con las opciones de columnas que prefiera.',
  escolhaColunasFiltrosIntro2: 'Esta función también está disponible en la lista de procesos, permitiéndole filtrar la visualización de procesos según sus necesidades.',

  habilitarAgendamento: 'Habilitar programación',
  cancelar: 'Cancelar',
  naoCancelar: 'No cancelar',
  excluirAgendamento: 'Eliminar la programación de informes?',
  naoRecuperavel: 'Una vez eliminado, no es posible recuperarlo',
  excluirAberturaProcesso: '¿Eliminar orden de suministro?',
  nossosEspecialistasVao:
    'Nuestros especialistas recibirán su solicitud y le responderemos por correo electrónico con los ajustes',
  recuperavel: 'Es posible recuperarlo después de la eliminación.',
  excluido: 'Eliminado correctamente',
  voltarAgendamentos: 'Volvamos a la lista de programación',
  tenteNovamente: 'Inténtalo de nuevo',
  confirmar: 'Confirmar',
  'Un. de Negócio': 'Un. de Negocio',
  'Un. de Medida': 'Un. de Medida',
  // INCENTIVO FISCAL
  incentivoFiscal: 'Incentivo Fiscal',
  icmsPago: 'ICMS Pagado',
  aliquotaIcmsPago: 'Alícuota ICMS pagado',
  formaDesconto: 'Forma de descuento',
  descontoIcmsPago: 'Descuento ICMS pagado',
  pctCliente: '% BC Cliente',
  pctGanhoLiquido: '% Ganancia Neta',
  valorCliente: 'Valor del Cliente',
  porcentagemCliente: '% Cliente',
  pctEmpresa: '% Empresa',
  // GED
  ged: 'Gestión electrónica de documentos',
  erroBaixarDocumento: 'Ocurrió un error al descargar el documento',
  baixarSelecionados: 'Descargar seleccionados',
  visualizarSelecionados: 'Ver seleccionados',
  Documento: 'Documento',
  Tipo: 'Amable',
  Extensão: 'Extensión',
  arquivoNaoSuportado: 'El archivo debe tener la extensión xlsx, xls o csv',
  Data: 'Fecha',
  // USUARIOS,
  Foto: 'Foto',
  Código: 'Código',
  'Criado em': 'Creado en',
  'Nome completo': 'Nombre completo',
  Email: 'E-mail',
  senha: 'Contraseña',
  confirmarSenha: 'Confirmar contraseña',
  criarSenha: 'Crear contraseña',
  caracteresSenha: 'De 8 à 25 caracteres',
  maiusculas: 'Al menos una letra mayúscula y una minúscula',
  letrasNumeros: 'Letras y números',
  caractereEspecial: "Carácter especial ! @ # $ % & * ' _ + = [ ] { } | : . ? ~ ( ) ; ,",
  adicionarUsuario: 'Agregar usuario',
  editarUsuario: 'Editar usuario',
  CNPJContatos: 'CNPJs y contactos responsables',
  notificacoes: 'Notificaciones',
  fotoPerfil: 'Foto de perfil',
  opcional: 'Opcional',
  empresas: 'Empresas',
  empresa: 'Empresa',
  tituloTooltipEmpresas: 'View the DNA and the people in charge of the registered companies.',
  nomeEmpresa: 'Nombre de la empresa',
  tipoUsuario: 'Tipo de usuario',
  responsavelComercial: 'Gerente comercial',
  nome: 'Nombre',
  responsavelOperacional: 'Gerente de operaciones',
  clientesCNPJ: 'CNPJ Enlazado',
  consultarCNPJ: 'Enlazar CNPJ',
  'Cód. Conexos': 'Cod. Conexos',
  Nome: 'Nombre',
  Cidade: 'Ciudad',
  UF: 'UF',
  'Razão Social': 'Relación común',
  adicionarSelecionados: 'Agregar seleccionado',
  receberNotificacoes: 'Recibir notificaciones',
  notificacoesWhatsapp: 'Notificaciones en WhatsApp',
  tipoNotificacao: 'Tipo de notificación',
  // DASHBOARD
  bemVindo: 'Bienvenido',
  tempoLiberacao: 'Tiempo de lanzamiento (días)',
  tempoLiberacaoProduto: 'Tiempo de lanzamiento por producto(días)',
  top10Produtos: 'Top 10 productos',
  acertoNumerario: 'Golpe de efectivo (%)',
  tempoMedioFechamento: 'Tiempo medio de cierre (días)',
  processos: 'Procesos',
  statusProcesso: 'Estado de proceso (%)',
  faturamento: 'Facturación',
  emTempo: 'A tiempo',
  verde: 'Verde',
  vermelho: 'Rojo',
  amarelo: 'Amarillo',
  cinza: 'Gris',
  Janeiro: 'Enero',
  Fevereiro: 'Febrero',
  Março: 'Marzo',
  Abril: 'Abril',
  Maio: 'Mayo',
  Junho: 'Junio',
  Julho: 'Julio',
  Agosto: 'Agosto',
  Setembro: 'Septiembre',
  Outubro: 'Octubre',
  Novembro: 'Noviembre',
  Dezembro: 'Diciembre',
  janeiro: 'Enero',
  fevereiro: 'Febrero',
  marco: 'Marzo',
  abril: 'Abril',
  maio: 'Mayo',
  junho: 'Junio',
  julho: 'Julio',
  agosto: 'Agosto',
  setembro: 'Septiembre',
  outubro: 'Octubre',
  novembro: 'Noviembre',
  dezembro: 'Diciembre',
  // FINANCEIRO
  modalidade: 'Modo',
  porcentagem: 'Porcentaje',
  tipoVencimento: 'Caducidad del tipo',
  dataVencimento: 'Fecha de vencimiento',
  valor: 'Valor',
  undefined: 'Objeto no encontrado',
  // MENSAGEIRO
  mensageiro: 'Mensajero',
  tituloTooltipMensageiro:
    'Programa el envío de informes al correo electrónico sobre \ntu proceso y mantente al tanto de las actualizaciones que ocurren.',
  Responsável: 'Responsable',
  'Última execução': 'Última ejecución',
  excluirAgendamentoPadrao: 'Eliminar programación?',
  excluirProduto: '¿Eliminar producto?',
  enviarEmail: 'Enviar correo electrónico ahora',
  agendamento: 'Planificación',
  agendar: 'Horario',
  erroSalvarAgendamentoMensageiro: 'Se ha producido un error al guardar la programación!',
  preenchaTodoAgendamento: 'Por favor complete todos los campos.',
  agendamentoSalvoComSucesso: 'Programación guardada correcta',
  redirecionamentoTelaListagem: 'Serás redirigido a la pantalla de listado.',
  Copiar: 'Copiar',
  Reenviar: 'Reenviar',
  enviar: 'Enviar',
  enviarEmailAgora: ' ¿Enviar correo electrónico ahora?',
  sucessoEnvioEmail: 'Email enviado con éxito!',
  processoCompartilhadoSucesso: 'Procesos compartidos con éxito',
  adiantado: 'Adelantado',
  obrigatorio: 'Atención: Campo obligatorio.',
  emailInvalido:
    'La dirección de correo electrónico ingresada parece ser incorrecta. Por favor, verifique y vuelva a intentarlo',
  cnpjInvalido: 'Atención: CNPJ no válido.',
  senhaInvalida: 'Atención: Las contraseñas no coinciden',
  senhasDiferentes: 'Advertencia: las contraseñas no coinciden',
  // notificações
  chegada: 'llegada',
  ativarNotificacoes: 'Activar todas las notificaciones',
  embarquePrevisto: 'Envío programado',
  embarqueEfetivo: 'Envío efectivo',
  manifestoCarga: 'manifiesto de carga',
  emailDestino: 'Correos electrónicos de destino',
  empresaSelecionadaNaoExiste: 'La empresa seleccionada no está registrada',
  cadastroEmpresa: 'Registro de la empresa',
  cadastroUsuario: 'Registro de usuario',
  emailEnviado: 'Correo electrónico enviado con éxito',
  vincularEmpresa: 'Compañías de enlace',
  frequencia: 'Frecuencia',
  campos: 'Campos',
  transitTime: 'Tiempo de transito',
  tituloTooltipTransitTime:
    'Visualiza el avance del proceso entre \nlas etapas y el tiempo estimado para su finalización.',
  ano: 'Año',
  dom: 'Dom',
  seg: 'Lun',
  ter: 'Mar',
  qua: 'Mie',
  qui: 'Jue',
  sex: 'Vie',
  sab: 'Sab',
  DI: 'DI',
  siscarga: 'Siscarga',

  // Tour
  tourCancelar: 'Cancelar',
  tourVoltar: 'Volver',
  tourProximo: 'Siguiente',
  tourFinalizar: 'Finalizar',

  tourBemVindo: '¡Bienvenido!',
  tourBemVindoMensagem: 'Vamos mostrarte nuestras principales funciones, es rápido.',

  tourMapa: 'Mapa',
  tourMapaMensagem: 'Realiza el seguimiento de los envíos de carga marítima y terrestre, así como de puertos, almacenes y fabricantes.',

  tourDashboard: 'Tablero',
  tourDashboardMensagem: 'Consulta gráficos y estadísticas sobre tus procesos, productos, flujo de efectivo y otra información.',

  tourFollowUp: 'Seguimiento',
  tourFollowUpMensagem: 'Sigue tu proceso a través de las etapas de importación.',

  tourMenu: 'Menú',
  tourMenuMensagem: 'Menú desplegable que te da acceso a los demás módulos disponibles en el sistema.',

  tourProcessos: 'Abrir Procesos',
  tourProcessosMensagem: 'Abre procesos y espera su avance.',

  tourGestaoLi: 'Gestión de LI',
  tourGestaoLiMensagem: 'Verifica las licencias necesarias para la importación.',

  tourDocumentos: 'Documentos',
  tourDocumentosMensagem: 'Analiza los documentos relacionados con tus procesos.',

  tourAgendarRelatorios: 'Programar Informes',
  tourAgendarRelatoriosMensagem: 'Programa informes personalizados para recibir por correo electrónico.',

  tourUsuarios: 'Usuarios',
  tourUsuariosMensagem: 'Agrega y configura usuarios para usar el sistema contigo.',

  tourSelecaoEmpresas: 'Selección de Empresas',
  tourSelecaoEmpresasMensagem: 'Filtra las empresas que deseas ver utilizando el CNPJ.',

  tourChat: 'Chat',
  tourChatMensagem: 'Haga preguntas e intercambie información con nuestra IA o con los especialistas.',

  tourTema: 'Temas',
  tourTemaMensagem: 'Cambia entre el tema claro y el tema oscuro.',

  tourNotificacoes: 'Notificaciones',
  tourNotificacoesMensagem: 'Consulta las actualizaciones de los procesos y configura el envío por correo electrónico.',

  tourPerfil: 'Perfil',
  tourPerfilMensagem: 'Edita tus datos, contempla las novedades de nuestra plataforma, vuelve a hacer el recorrido o cambia de cuenta de acceso.',

  tourMapaFuncionalidade: 'Opciones del Mapa',
  tourMapaFuncionalidadeMensagem: 'Puedes centrar, ampliar y reducir el zoom del mapa.',

  tourMapaFiltros: 'Filtros del Mapa',
  tourMapaFiltrosMensagem: 'Opción para filtrar los procesos según su estado.',

  tourObrigado: 'Gracias por tu atención',
  tourObrigadoMensagem: 'Si aún tienes dudas, ponte en contacto con nuestro equipo.',
  removerDemanda: '¿Quieres eliminar esta demanda?',
  possivelRecuperar: 'Es posible recuperar después de la eliminación',
  proximo: 'Próximo',
  itemAdicionado: '¡Artículo agregado! ¿Registrar artículo?',
  disponivelNCM:
    'El artículo quedará registrado en nuestra base de datos y podrá reutilizarlo en futuras operaciones.',
  fechar: 'Cerrar',
  preenchaTudo: 'Rellene todos los campos antes de registrar un artículo.',
  produtoSalvo: '¡Producto registrado con éxito!',
  produtoJaCadastrado: 'El producto ya está registrado.',
  produtoDeletado: '¡Producto eliminado con éxito!',
  ncmAutomatico:
    'Ingrese el código NCM, si está en nuestra base de datos, la información se llenará de forma automática, parcial o total.',
  configuracoes: 'Ajustes',
  statusAlterado: 'Status cambiado',
  hoje: 'Hoy',
  ontem: 'Ayer',
  estaSemana: 'Esta semana',
  semanaPassada: 'Semana pasada',
  esteMes: 'Este mes',
  anteriores: 'Anterior',
  assimQueAtualizar: 'Tan pronto como actualices',
  diariamente: 'Diariamente',
  semanalmente: 'Semanal',
  desabilitarEnvio: 'Deshabilitar enviar',
  dataRegistroDI: 'Registro DI',
  numeroProtocoloDI: 'Número de protocolo DI',
  dataDesembaracoDI: 'Liquidación DI',
  dataAbertura: 'Apertura',
  dataFechamentoOperacional: 'Cierre Operativo',
  dataExecucaoCarregamento: 'Cargando Ejecución',
  carregamentoAgendado: 'Carga programada',
  dataFaturamento: 'Facturación',
  dataEnvioFaturamento: 'Envío de facturación',
  emissaoNotaEntrada: 'Emisión de nota de entrada',
  dataPresencaCarga: 'Presencia de carga',
  conhecimentoEmbarque: 'Conocimiento de embarque',
  dataVistoriaMapa: 'Inspección de MAPA',
  dataRecebimentoOriginais: 'Recepción de Documentos',
  cadastrarUsuario: 'Registrar usuario',
  listarUsuario: 'Lista de usuarios',
  legenda: 'Caja de información',
  refazerTour: 'Volver a hacer el Tour',
  sairConta: '¿Estás seguro(a) de que quieres cerrar sesión?',
  zoomIn: 'Acercarse',
  zoomOut: 'Disminuir el zoom',
  centralizarMapa: 'Volver a centrar',
  registroNaoEncontrado: 'Artículo no encontrado, inténtalo de nuevo',
  processoNaoPossuiLocalizacaoMapa: 'El elemento no tiene geolocalización registrada',
  avisoCamposObrigatorios: 'Los campos marcados con * son de cumplimentación obligatoria.',
  maisDetalhes: 'Más detalles',
  codigoProduto: 'Código de producto',
  lote: 'Lote',
  loteFabricacao: 'Lote de fabricación',
  dataFabricacao: 'Fecha de fabricación',
  codigoPallet: 'Código do Pallet',
  codigoSequenciaLote: 'Secuencia por lotes',
  dataMovimentacao: 'Fecha de mudanza',
  numeroLote: 'Numero de lote',
  numeroLoteFabricacao: 'Número de lote de fabricación',
  quantidadeBloqueada: 'Cantidad bloqueada',
  quantidadeEmpenhada: 'Cantidad prometida',
  carregarTemplate: 'Cargar plantilla',
  importarModelo: 'Importar datos del modelo',
  baixarModelo: 'Descargar plantilla',
  solteArquivos: 'Arrastra y suelta tus archivos aquí.',
  arquivosPermitidos: 'Archivos permitidos: XLSX, DOC y PDF.',
  solteCarregar: 'Arrastra los archivos aquí para subirlos.',
  carregandoArquivos: 'Cargando archivos...',
  verifiqueAntesSalvar: 'Revisa los campos antes de guardar.',
  processoExiste: 'Este número de referencia ya existe, consulte.',
  valorTotal: 'Valor total',
  codigoNCM: 'Código NCM',
  descricaoDetalhada: 'Descripción detallada',
  produtos: 'Productos',
  tituloTooltipProdutos:
    'Registra productos para importarlos a tus procesos y tener un historial de todo.',
  // MENSAGENS DE VALIDACOES CADASTRO DE PRODUTOS
  valorUnitarioPositivo: 'El valor unitario debe ser mayor que cero',
  quantidadePositivo: 'El campo de cantidad debe ser mayor que cero',
  preenchaCampoProdutor: 'El campo de productor está vacío, por favor complete',
  preenchaCampoFornecedor: 'El campo de proveedor está vacío, por favor complete',
  preenchaCampoCodigoCliente: 'El campo de código de cliente está vacío, por favor complete',
  preenchaCampoProduto: 'El campo de producto está vacío, por favor complete',
  preenchaCampoUnidadeMedida: 'El campo de unidad de medida está vacío, por favor complete',
  preenchaCampoNCM: 'El campo de código de NCM está vacío, por favor complete',
  preenchaCampoMoeda: 'El campo de moneda está vacío, por favor seleccione una de las monedas',
  preenchaCampoEmpresa: 'El campo de empresa está vacío, por favor seleccione una de las empresas',
  maximo10characteres: 'Este campo debe tener como máximo 10 caracteres.',
  maximo20characteres: 'Este campo debe tener como máximo 20 caracteres.',
  maximo100characteres: 'Este campo debe tener como máximo 100 caracteres.',
  excluirUsuario: '¿Borrar usuario?',
  //////////////////////////////// ERROS
  ERRO_INTERNO_SERVIDOR_LOGIN:
    'Lamentamos, pero ocurrió un error interno en nuestro servidor al intentar iniciar sesión. Estamos trabajando para corregir el problema y pedimos disculpas por las molestias. Intente nuevamente en unos minutos o comuníquese con nuestro equipo de soporte técnico para obtener ayuda. Gracias por su comprensión.',
  Actions: 'Aciones',
  ncm: 'Código NCM',
  //TAREFAS
  pendente: 'Pendiente',
  administrativo: 'Administrativo',
  aguardando: 'Esperando',
  regulatorio: 'Regulatorio',
  novoProduto: 'Nuevo producto',
  cadastroNovoProduto: 'Nuevo producto',
  regulatorioCadastroNovoProduto: 'Nuevo producto / regulatorio',
  REGULATORIOCADASTRONOVOPRODUTO: 'Nuevo producto / regulatorio',
  cadastros: 'Registros',
  cancelamentos: 'Cancelaciones',
  acompanhamento: 'Seguimiento',
  liberacao: 'Liberación',
  nacionalizacao: 'Nacionalización',
  gestaoTarefas: 'Gestión de tareas',
  id: 'ID',
  licenciamento: 'Licenciamiento',
  validacaoRegulatorio: 'Validación regulatoria',
  historico: 'Histórico',
  processoMovido: 'Proceso movido a',
  comentar: 'Comentar',
  reenviarAcesso: '¿Deseas enviar un correo electrónico con un nuevo acceso? La contraseña actual cambiará.',
  tarefas: 'Tareas',
  tarefasProcessoPendente: 'Proceso pendiente',
  tarefasTratamentoAdministrativo: 'Tratamiento administrativo',
  tarefaRegulatorioCadastroNovoProduto: 'Nuevo producto / regulatorio',
  tarefasAcompanhamento: 'Seguimiento post-embarque',
  tarefasLiberacao: 'Liberación',
  tarefasNacionalizacao: 'Nacionalización',
  tarefasFechamento: 'Cierre',
  cardJaEstaEmAnaliseProduto: 'Esta tarjeta ya fue creada en la etapa de Nuevo producto / Regulatorio',
  atividades: 'Actividades',
  atribuirMim: 'Asignarme',
  proximaEtapa: 'Próxima etapa',
  sim: 'Sí',
  nao: 'No',
  conferido: 'Verificado',
  filtrosFavoritos: 'Filtros favoritos',
  vincularFiltroModelo: '¿Deseas vincular la última búsqueda/filtro a este modelo?',
  salvarUmFiltro: 'Guardar un filtro',
  criarUmNovoFiltro: 'Crear un filtro favorito',
  editarFiltro: 'Editar filtro',
  filtroSalvo: 'Filtro guardado con éxito',
  filtroAtualizado: 'Filtro actualizado',
  fltroAplicado: 'Filtro aplicado',
  envioDocumentosFechamento: 'Envío de documentos',
  editarObservacao: 'Editar observación',
  regulatoriocadastronovoproduto: 'regulatorio y cadastro nuevo produto',// Tareas actividades administrativo
  aberturaProcessoConexos: 'Apertura de proceso en conexos',
  aberturaPastaNuvem: 'Apertura de carpeta en la nube',
  responderEmailAbertura: 'Responder correo electrónico de apertura',
  tratamentoTributario: 'Tratamiento tributario / Clasificación Fiscal NCM / Administrativo',
  instrucaoDespacho: 'Instrucción de despacho - ID',
  verificacaoCadastroProduto: 'Verificación de registro del producto / Proveedores',
  lancamentoCadastroInvoice: 'Registro / Cadastro de Invoice en Conexos',
  conferenciaDocumental: 'Conferencia documental',
  solicitacaoFreetime: 'Solicitud de Free-time',
  simulacaoCliente: 'Enviar simulación del cliente',
  emissaoLiPreEmbarque: 'Emisión del LI Pré-embarque',
  cotacaoFreteInternacional: 'Cotización de Flete Internacional',
  fechamentoCambio: 'Cierre de cambio',
  provisionamentoCambio: 'Provisionamiento de cambio',
  acompanhamentoDeferimentoLiPosEmbarque: 'Deferimiento LI post-embarque',
  emitirLi: 'Emitir LI',
  liPre: 'LI pre',
  liPos: 'LI post',
  semLI: 'Sin LI',
  solicitadoNF: 'Solicitado NF',
  checklistNotaRealizado: 'Checklist nota realizado',
  solicitacaoEmissaoEnviadoFaturamento: 'Solicitud de emisión enviado al facturación',
  concluidos: 'Completados',
  esconderColunaConcluidos: 'Ocultar columna de completados',
  exibirColunaConcluidos: 'Mostrar columna de completados',
  // Tareas actividades nuevoProducto
  recebimentoDescricao: 'Recepción de descripción / NCM / Datos del proveedor',
  formularioCadastroProduto: 'Formulario para registro de producto',
  formularioCadastroFornecedores: 'Formulario para registro de proveedores',
  aberturaChamadoCadastro: 'Apertura de ticket de registro',
  produtoCadastrado: 'Producto registrado',
  liberadoImportacao: 'Importación liberada',
  armazenagem: 'Almacenamiento',
  transporte: 'Transporte',
  // Tareas actividad regulatório
  envioFormularioRegulatorio: 'Envío de formulario para lo Regulatorio',
  envioDocumentos: 'Envío de documentos / MSDS / FISPIQ',
  pendenciaDocumental: 'Pendencia documental / informaciones',
  analiseRegulatorioLiberado: 'Análisis Regulatorio Liberado',
  // Tareas actividad acompanhamento
  cadastroConhecimentoConexos: 'Registro de conocimiento de embarque en conexos',
  documentosOriginais: 'Documentos originales',
  telex: 'Telex',
  conferenciaCeMercante: 'Conferencia CE Mercante',
  envioNumerario: 'Envío numerario',
  digitacaoDI: 'Digitación de DI',
  lancamentoMapaMadeira: 'Registro Mapa Madeira',
  verificacaoValorConta: 'Verificación de valor en cuenta',
  autorizacaoRegistroDI: 'Autorización de registro DI / AFRMM',
  provisionamentoNumerarioEncomendaPadrao: 'Provisionamiento numerario encomienda estándar',
  liberacaoSiscargaBL: 'Liberación Siscarga/BL',
  envioParaAnuencia: 'Envío para anuencia',
  blRetirado: 'B/L Retirado',
  // Tareas actividades nacionalización
  envioDiRegistrada: 'Envío de DI registrada',
  envioCI: 'Envío de CI',
  liberacaoBL: 'Liberación de BL',
  desbloqueioSiscarga: 'Desbloqueo del Siscarga',
  solicitarExoneracaoICMS: 'Solicitar exoneración ICMS',
  montarNF: 'Montar NF / Verificar gastos para NF',
  liberacaoComex: 'Liberación comex',
  recebimentoNfTrust: 'Recepción NF Trust',
  programacaoCarregamento: 'Programación de carga cliente y transporte',
  liberacaoFaturamentoTerminal: 'Liberación de facturación del terminal',
  agendamentoRetirada: 'Agendamiento de retiro',
  minutaDevolucaoCNTR: 'Minuta devolución CNTR',
  lavacaoAvaria: 'Lavado / Avería',
  aguardandoRIC: 'Esperando RIC',
  envioFechamento: 'Envío para cierre',
  exoneradoAguardando: 'Esperando exoneración o Exonerado',
  // Tareas actividades fechamento
  acompanharProcesso: 'Acompañar cierre proceso',
  // USUARIOS
  usuarioRemovido: 'Usuario eliminado correctamente',
  acessoEnviado: 'El acceso ha sido enviado al correo electrónico del usuario',
  excluirProprioUsuario: '¡No puedes eliminar tu propio usuario!',
  naoPodeReenviar: '¡No puedes volver a enviar tu propio correo electrónico y primer acceso!',
  usuarioAtualizado: 'Usuario actualizado correctamente',
  usuarioInserido:
    'Usuario insertado correctamente! Por favor, espera a que se genere la contraseña y se envíe al correo electrónico',
  naoRecuperouUsuario: 'No se pudieron recuperar los datos del usuario',
  formatoInvalido: '¡El formato del campo es inválido!',
  nomeLetras: 'El nombre debe contener al menos 3 letras!',
  nomeMaxLetras: 'El nombre debe contener un máximo de 50 letras!',
  campoObrigatorio: '¡Este campo es obligatorio!',
  emailFormato: 'Formato de correo electrónico inválido.',
  emailMaxLetras: 'El campo de correo electrónico debe contener un máximo de 80 letras!',
  especifiqueUsuario: 'Especifique el tipo de usuario',
  senhaLetras: 'La contraseña debe contener al menos 8 caracteres.',
  senhaMaxLetras: 'La contraseña debe contener un máximo de 25 caracteres.',
  senhaDiferentes: 'Las contraseñas no son iguales.',
  historicoCompleto: 'Modo de historia completa',
  descricaoHistorico:
    '<p>El modelo histórico incluye en cada correo electrónico de actualización <span style:"text-decoration: underline">todas las etapas recorridas</span> por el proceso con fechas y contexto. Puedes activar el botón y recibirlo en este formato.</p> <p>Si lo desactivas, el contenido del correo electrónico será solo la última actualización.</p>',
  limpar: 'Limpiar',
  ativo: 'Activar',
  desativado: 'Disactivado',
  naoDigiteUnidadeMedida: 'No ingrese la unidad de medida',
  avisoViaEmail: '¿Recibir una notificación por correo electrónico?',
  emailsDestinos: 'Correos electrónicos de destino',
  estoque: 'Inventario',
  estoqueDisponivel: 'Existencias disponibles',
  estoqueLimite: 'Existencias agotándose o agotadas',
  receberAvisoEstoqueText: 'Indique en la tabla cuando el inventario esté *',
  estoqueMinimoAtualizadoSucesso: 'El stock mínimo se ha actualizado correctamente.',
  minimoEstoqueDesejado: 'Stock mínimo deseado',
  naoDefinido: 'No definido',
  legendaSemConfiguracaoEstoqueMinimo: 'Configuración no definida',
  legendaEmailDesativadoErroEstoqueMinimo:
    'Stock por debajo del mínimo y correo electrónico desactivado',
  legendaEmailDesativadoEstoqueMinimo: 'Stock disponible y correo electrónico desactivado',
  legendaEstoqueMinimoAlerta: 'El stock está por debajo del mínimo definido',
  legendaEstoqueMinimoErro: 'El stock está agotado',
  legendaEstoqueMinimoIdeal: 'Stock disponible',
  formatoCampoEmailInvalido: 'Formato de correo electrónico no válido',
  requiredFieldValorEstoqueMinimo: 'Campo Stock Mínimo vacío',
  requiredFieldTypeErrorNumber: 'El campo stock mínimo tiene que ser un número',
  requiredFieldEmail:
    'El campo Correo electrónico está vacío, inserte al menos un correo electrónico válido',
  // AG-GRID
  equals: 'Igual',
  notEqual: 'Diferente de',
  blank: 'Vacío',
  notBlank: 'No vacío',
  contains: 'Contiene',
  notContains: 'No contiene',
  startsWith: 'Empieza con',
  endsWith: 'Termina con',
  filter: 'filtrar',
  andCondition: 'E',
  orCondition: 'O',
  busqueCNPJ: 'Búsqueda de empresas por nombre o CNPJ.',
  removerEmpresas: 'Eliminar empresas',
  aplicar: 'Aplicar',
  cliqueCardDetalhes: 'Haga clic en la tarjeta para más detalles',
  fechamento: 'Cierre',
  pending: 'Pendiente',
  in_transit: 'Em tránsito',
  occurrence_treatment: 'Ocurrencia de manejo',
  done: 'Entregado',
  motorista: 'Conductor',
  placa: 'Treiber',
  valorNF: 'Valor de la factura',
  pesoRealNF: 'Peso real de la factura',
  tituloEstoqueMinimo: 'Stock Mínimo',
  buscaAvancada: 'Búsqueda Avanzada',
  codProcesso: 'Cód. Processo',
  paisOrigem: 'País origen',
  paisDestino: 'País destino',
  placaRodoviario: 'Placa (Camino)',
  dataEntregaContainer: 'Fecha de entrega del contenedor',
  removerSelecionados: 'Eliminar seleccionados',
  marcarDesmarcarTodos: 'Marcar / Desmarcar todo',
  // Tarefas atividades liberacao
  pagamentoTaxaBL: 'Pago de tarifas BL / Flete',
  envioDocumentacaoLiberacaoBL: 'Envío de documentación de liberación de BL',
  demurrage: 'Demora',
  nvioFechamento: 'Envío para cierre',
  // Tarefas atividades fechamento
  recebimento: 'Recepción',
  verificacaoRazaoProcesso: 'Verificación de la razón del proceso',
  envioFechamentoCliente: 'Envío de cierre al cliente',
  gestaoLicencasImportacao: 'Licencias de Importación',
  gestaoLI: 'Gestión de L.I.',
  licencaImportacao: 'Licencia de Importación',
  visualizeLI:
    'Acompañe las licencias necesarias para la importación, buscando la regulación del comercio internacional y la protección de la economía nacional.',
  dataSituacao: 'Fecha de Situación',
  li: 'LI',
  dataReg: 'Fecha de Registro',
  validadeSituacao: 'Validez de Situación',
  dataProtocolo: 'Fecha de Protocolo',
  anuencia: 'Anuencia',
  paraAnalise: 'Para Análisis',
  emExigencia: 'En Demanda',
  deferida: 'Aprobada',
  encaminhar: 'Enviar',
  encaminharProcessoEmail: 'Enviar proceso por correo electrónico',
  verMais: 'Ver más',
  verMenos: 'Ver menos',
  dataTransbordo: 'Transferencia',
  dataTransbordo2: 'Segunda transferencia',
  sequencia: 'Secuencia',
  ultimoAcesso: 'Último acceso',
  cliqueAdicionarProduto: 'Haga clic para agregar un nuevo producto',
  house: 'Casa BL',
  master: 'Maestro BL',
  tipoContainer: 'Tipo de contenedor',
  armador: 'Naviero',
  lacre: 'Sello',
  dataChegadaContainer: 'Llegada del contenedor',
  vencimentoFreetime: 'Vencimiento del Freetime',
  situacaoEvento: 'Estado del evento',
  containerDevolvido: 'Contenedor devuelto',
  dataEvento: 'Fecha del evento',
  situacaoEventoArmador: 'Estado del evento por naviera',
  nomeNavio: 'Nombre del buque',
  localEvento: 'Ubicación del evento',
  identificacaoViagem: 'Identificación del viaje',
  dataViagem: 'Fecha del viaje',
  Modalidade: 'Modalidad',
  Porcentagem: 'Porcentaje',
  Valor: 'Valor',
  Invoice: 'Invoice',
  'Tipo vencimento': 'Tipo de Vencimiento',
  statusDoProcesso: 'Estado del processo',
  reenviarEmailProcesso: 'Reenviar e-mail de proceso',
  erroAoEnviarEmail: 'Hubo un error al enviar el correo electrónico',
  aperteEnterParaCadaEmail: 'Presione la tecla Intro para cada dirección de correo electrónico ingresada',
  tipoDeImportacao: 'Tipo de importación',
  cliqueParaBaixar: 'Haga clic para descargar',
  Abertos: "Abiertos",
  Encerrados: "Encerrados",
  extratoLI: 'extracto de licencia',
  // ged
  documentoBaixadoSucesso: 'Documento descargado exitosamente',
  erroVisualizarDocumento: 'Se produjo un error al visualizar el documento',
  // gestao containers
  containersNaoEncontrados: 'Contenedores no encontrados para este tipo de filtro.',
  //Produtos Processos
  'PET - RESINA': 'PET - RESINA',
  'PVC - RESINA': 'PVC - RESINA',
  'PROPRIO DIVERSOS': 'PROPIO VARIOS',
  'SUPLEMENTOS': 'SUPLEMENTOS',
  // GRÁFICOS
  indicadores: 'Indicadores',
  licencasDeferidas: 'Licencias concedidas',
  licencasComExigencia: 'Licencias con requisitos',
  licencasSemExigencia: 'Licencias sin requisitos',
  tempoAberturaDeferimento: 'Tiempo desde la apertura hasta la concesión (días)',
  expectativaChegada: 'Expectativa de llegada',
  codCalculo: "Código de cálculo de ingresos/costos",
  estadoCalculo: "Estado de cálculo de ingresos/costos",
  dataInicio: "Fecha de inicio",
  dataFim: "Fecha de finalización",
  valorServico: "Valor del servicio",
  valorCalculado: "Valor calculado",
  ordemCompra: 'Orden de compra',
  aVista: 'A la vista',
  aPrazo: 'Cuotas',
  termosPagamento: 'Términos de pago',
  portoOrigem: 'Puerto de origen',
  portoDestino: 'Puerto de destino',
  enderecoExportador: 'Dirección del exportador',
  selecionarCNPJ: 'Seleccione y agregue CNPJ al usuario',
  vincular: 'Enlace',
  // TabName
  'Login': 'Acceso',
  'Home': 'Inicio',
  'AberturaProcesso': 'Nuevos procesos',
  'ProcessosKanban': 'Follow-Up',
  'GestaoLI': 'Gestión de LI',
  'ListagemProcesso': 'Listado de Procesos',
  'TransitTime': 'Tiempo de Transito',
  'Estoque': 'Inventario',
  'Financeiro': 'Financiero',
  'AgendamentoRelatorios': 'Informes',
  'Ged': 'Gestión electrónica de documentos',
  'Mensageiro': 'Mensajero',
  'Tarefas': 'Gestión de tareas',
  'ListarUsuarios': 'Usuarios',
  'Produtos': 'Productos',
  'Dashboard': 'Dashboard',
  'Empresas': 'Empresas',
  'Manutencao': 'Mantenimiento',
  'RecuperarSenha': 'Olvidó su contraseña',
  'processosParceiros': 'Socios',
  'processosComissao': ' Socios',
  bugs: 'Bugs: ',
  melhorias: 'Mejoras: ',
  manutencao: 'Mantenimiento: ',
  novidades: 'Novedades: ',
  patchNotes: 'Notas de Actualización',
  assistente: 'Asistente',
  assistente1: 'Asistente 1',
  assistente2: 'Asistente 2',
  assistentes: 'Asistentes',
  introPatchNotes1: 'Estas son solo algunas de las mejoras y características introducidas en cada versión de Trinity. Siempre estamos comprometidos en mejorar la plataforma y ofrecerte la mejor experiencia posible.',
  introPatchNotes2: 'Estaremos compartiendo información sobre futuras versiones y emocionantes características que están por venir.',
  manutencoes: 'Mantenimientos',
  acoes: 'Acciones',
  aguardandoAtualizacao: 'Esperando actualización',
  copiarLinkProcesso: 'Copiar enlace de proceso',
  estrategico: 'Estratégico',
  chat: 'Chat',
  entendi: 'Entiendo',
  aindaNaoembarcado: 'Aún no embarcado',
  seuProcessoAindaNaoEmbarcado: 'Su proceso aún no ha sido embarcado.',
  fiqueOlho: 'Mantén un ojo en los próximos días.',
  ops: 'Oops',
  processoNaoEncontrado: 'Este proceso no se encontró.',
  naoRegistrado: 'Puede ser que su barco esté en una zona sin radar o que no haya sido registrado.',
  transporteAereo: 'Transporte aéreo',
  seuProcessoAereo: 'Su proceso está en el modo de transporte aéreo.',
  naoApareceMapa: 'Este modo no aparece actualmente en el mapa.',
  transitoConcluido: 'Tránsito concluido',
  processoNaoTransito: 'Su proceso ya no está en tránsito.',
  cliqueDetalhesProcesso: 'Haga clic para ver los detalles de este proceso.',
  verDetalhes: 'Ver detalles',
  // CRC
  crcMenu: 'Costos Alm...',
  crc: 'Costos Almacén',
  codigoCRC: 'Código Cálculo Ingreso/Costo',
  estadoCRC: 'Estado Cálculo Ingreso/Costo',
  descricaoServico: 'Descripción del servicio',
  quantidadeServico: 'Cantidad de servicio',
  editarEmpresa: 'Editar empresa',
  // Cadastro basico
  cadastroBasico: 'Registros básicos',
  fornecedorProdutor: 'Proveedor / Productor',
  siglaSimbolo: 'Abreviatura/Símbolo',
  Cadastro: 'Registro',
  salvoComSucesso: 'guardado con éxito',
  deletadoComSucesso: 'fue eliminado con éxito',
  sigla: 'Abreviatura',
  tipo: 'Tipo',
  alta: 'Alto',
  media: 'Medio',
  baixa: 'Bajo',
  prioridade: 'Prioridad',
  // DNA Empresas
  sequencial: 'Secuencial',
  questionario: 'Cuestionario',
  questionarios: 'Cuestionarios',
  perguntas: 'Preguntas',
  respostas: 'Respuestas',
  perguntasAndRespostas: 'Preguntas y Respuestas',
  responsavelComex: 'Gerente de Comercio Exterior',
  assistenteComex: 'Asistente de Comercio Exterior',
  responsavelExecutivo: 'Gerente Ejecutivo',
  //
  totalProcessosDescricao: 'Procesos en curso por estado',
  statusProcessosDescricao: 'En relación con la previsión de envío original',
  canalParametrizacaoDescricao: 'En relación con los procesos en curso',
  topProdutosDescricao: 'En relación con la cantidad de facturas',
  acertoNumerarioDescricao: 'En relación entre el valor Estimado vs el valor Realizado',
  tempoLiberacaoFechamentoDescricao: 'En relación con la fecha de presencia de la carga',
  //
  placeholderFornecedorProdutorInputNome: 'Empresa Ejemplo S.A.',
  placeholderFornecedorProdutorInputCNPJ: '00.000.000/0001-00',
  placeholderMoedaInputSiglaSimbolo: 'USD',
  placeholderMoedaInputDescricao: 'Dólar Estadounidense',
  placeholderUnidadeMedidaInputSiglaSimbolo: 'KG',
  placeholderUnidadeMedidaInputDescricao: 'Kilogramos',
  recuperarRascunho: 'Restaurar borrador',
  previsao: 'Previsión',
  messageAddInformacionRegistroBasico: "Si desea agregar un nuevo elemento, por favor, póngase en contacto con un administrador.",
  mensagemCampoDescricaoCadastroBasico: 'El campo de descripción debe contener al menos 5 caracteres.',
  mensagemCampoSiglaMoeda: 'El campo de abreviatura debe contener al menos 3 caracteres.',
  mensagemCampoSiglaUnidadeMedida: 'El campo de abreviatura debe contener al menos 2 caracteres.',
  mensagemCampoNomeFornecedorProdutor: 'El campo de nombre debe contener al menos 5 caracteres.',
  mensagemCampoCNPJFornecedorProdutor: 'El campo CNPJ no necesita estar formateado; solo los números son suficientes.',
  mensagemCampoCNPJLenghtFornecedorProdutor: 'El campo CNPJ debe contener 14 caracteres.',
  cadastrosBasicos: 'Registro básico',
  // Simulação
  Simulacao: 'Simulación',
  simulacao: 'Simulación',
  classificacao: 'Clasificación',
  filial: 'Afiliado/Beneficios',
  solicitadoEm: 'Solicitado en',
  recuperarSenha: 'Recuperar senha',
  nenhumaEmpresaColuna: 'Ninguna empresa en esta columna',
  nunhumProcessoEncontrado: 'No se encontró ningún proceso nuevo',
  abrirVisualizarAndamentoFollowup: 'Puede abrir un nuevo proceso o ver lo que está en curso en el Follow-Up',
  tooltipDataLiberacaoSiscarga: 'Fecha de liberación del B/L (retiro de la retención)',
  tooltipDataLiberacaoMapa: 'Fecha en que el ministerio de agricultura libera el embalaje de madera de la mercancía',
  tooltipPresencaCarga: 'Fecha en que el recinto aduanero informa que el contenedor está en el terminal',
  LI: 'LI',
  II: 'II',
  IPI: 'IPI',
  PIS: 'PIS',
  COFINS: 'COFINS',
  'COFINS CUSTO': 'COFINS COSTO',
  ICMS: 'ICMS',
  'PIS SAIDA': 'PIS SALIDA',
  'COFINS SAIDA': 'COFINS SALIDA',
  'MARKTUP': 'MARKTUP',
  'DESCONTO': 'DESCUENTO',
  comissoes: 'Comisiones',
  parceiros: 'Importar promueve el crecimiento',
  DashboardContainers: "Dashboard",
  min: "Mínimo",
  max: "Máximo",
  avg: "Promedio",
  median: "Mediana",
  count: "Conteo",
  escolhaAbaixo: 'Elija abajo',
  referenciaProcesso: 'Referencia del proceso',
  valorComissao: 'Monto de la comisión',
  parcelasPagamento: 'Cuotas de pago',
  dataComissao: 'Fecha de la comisión',
  icms: 'ICMS',
  valorIcms: 'Monto de ICMS',
  tipoImportacao: 'Tipo de importación',
  ocultar: 'Ocultar',
  exibir: 'Mostrar',
  'Cliente': 'Cliente',
  nomeArquivo: 'Nombre del Archivo',
  novoProcesso: 'Nuevo Proceso',
  referenciaPO: 'Referencia (PO o Factura)',
  expandirDiminuir: 'Expandir / Colapsar',
  downloadPDF: 'Descargar PDF',
  recarregar: 'Recargar',
  // Pré faturamento
  preFaturamento: 'Prefacturación',
  carregamentoProgramado: 'Carga programada',
  horario: 'Horario',
  liberacaoMapa: 'Liberación de mapa',
  liberacaoSiscarga: 'Liberación Siscarga',
  transportador: 'Transportista',
  taxaCambialDI: 'Tipo de cambio D.I',
  beneficioFiscal: 'Beneficio fiscal',
  descricaoItem: 'Descripción del artículo',
  despachante: 'Despachador',
  armazemDesembaraco: 'Almacén de despacho',
  recintoEntrada: 'Recinto de entrada',
  codigoInvoice: 'Código de factura',
  quantidadeContainers: 'Cantidad de contenedores',
  quantidadeLIs: 'Cantidad de LI\'s',
  diasLivres: 'Días libres',
  CE: 'C.E',
  desembaraco: 'Despacho',
  saldoConta: 'Saldo de cuenta',
  custosAlocadosOutroProcesso: 'Costos asignados de otro proceso',
  THC: 'THC',
  observacoesProcesso: 'Observaciones del proceso',
  codigo: 'Código',
  emissao: 'Emisión',
  numeroDocumento: 'N° Doc',
  adiantamento: 'Adelanto',
  descricaoPessoa: 'Descripción de persona',
  uf: 'UF',
  numAdicao: 'N° Adição',
  numItem: 'N° Item',
  codigoExportacao: 'Código de Exportación',
  contaProjeto: 'Cuenta de Proyecto',
  valorMoedaNacional: 'Valor en Moneda Nacional',
  formaRateio: 'Forma de Distribución',
  encargo: 'Cargo',
  ONU: 'ONU',
  descricaoCliente: 'Descripción del Cliente',
  embalagem: 'Embalaje',
  nomePasta: 'Nombre de la Carpeta',
  informacoesProcesso: 'Información del proceso',
  financeiroPagar: 'Financiero a pagar',
  comparativoProdutosDIs: 'Comparativo producto(s) D.I.',
  comparativoProdutoInvoice: 'Comparativo producto Invoice',
  custosEmissaoNF: 'Costos para emisión de la NF',
  produtosProcesso: 'Productos del proceso',
  documentosGED: 'Documentos GED',
  comparativosProdutoDIs: 'Comparativo producto(s) D.I.',
  mensagemRascunhos: 'Retome las informaciones de solicitudes anteriores que no fueron finalizadas.',
  editarSolicitacaoProcesso: 'Editar solicitud de proceso',
  prazoPagamento: 'Plazo de pago',
  downloadExcel: 'Download table in Excel',
  substituta: 'Sustituta',
  limparFiltros: 'Limpiar filtros',
  valoresInvoice: 'Total de productos facturados',
  PrevisaoArmazem: 'Previsión de Almacén',
  DiasRestantesChegada: 'Días restantes para la llegada',
  dataMovimento: 'Fecha de movimiento',
  segmentoProduto: "Segmento del producto",
  valorProcesso: "Valor total del proceso",
  dataChegouPorto: 'La carga ya llegó al puerto de destino',
  previsaoDemandaDomestica: 'Previsión de demanda doméstica',
  PrevisaoDemandaDomestica: 'Previsión de demanda doméstica',
  demandaDomestica: 'Demanda doméstica',
  processosPendentes: 'Procesos pendientes',
  bl: 'BL',
  enviosEmail: 'Envíos por correo electrónico',
  esteProcessoPossui: 'Este proceso tiene',
  um: 'Uno',
  acabouAberto: 'acaba de ser abierto',
  "tooltipAbertura": "Inicio formal del proceso de importación con la Trading, comenzando los trámites legales y administrativos.",
  "tooltipDataEmbarque": "Día en que las mercancías son efectivamente cargadas en el medio de transporte para ser enviadas del país de origen al país de destino.",
  "tooltipRegistroDI": "La Declaración de Importación registra detalles como datos del fabricante, importador, clasificación fiscal y valores de impuestos. Se trata de un requisito previo para el despacho aduanero.",
  "tooltipVistoriaMapa": "El Ministerio de Agricultura, Ganadería y Abastecimiento es responsable de la fiscalización del tránsito internacional de los embalajes, impidiendo el ingreso de plagas.",
  "tooltipETA": "Fecha estimada de llegada del barco al puerto.",
  "tooltipETD": "Fecha estimada de salida del barco del puerto.",
  "tooltipRecebimentoOriginais": "Son los documentos instructivos del proceso, por ejemplo: Factura, lista de empaque y BL.",
  "tooltipTransbordo": "Las mercancías tendrán que cambiar de barco durante el viaje, por la ruta ya trazada.",
  "tooltipSegundoTransbordo": "Las mercancías tendrán que cambiar de barco por segunda vez durante el viaje, por la ruta ya trazada.",
  "tooltipDataLiberaçãoMapa": "Fecha en que el Ministerio de Agricultura, Ganadería y Abastecimiento autoriza la liberación de las mercancías, mediante fiscalización documental o física.",
  "tooltipDataChegada": "Momento en que las mercancías importadas llegan al puerto de destino, marcando el inicio de los procedimientos aduaneros y logísticos.",
  "tooltipDesembaracoDI": "Despacho aduanero de la Declaración de Importación. Incluye el análisis y aprobación por parte de la aduana de los documentos de importación, permitiendo la liberación de las mercancías.",
  "tooltipConhecimentoEmbarque": "También conocido como Conocimiento de Embarque (B/L), sirve como recibo para las mercancías embarcadas y como documento de título de posesión de las mercancías durante el transporte.",
  "tooltipEmissãoNotaEntrada": "Generación de documento fiscal por parte de la empresa importadora que se utiliza para formalizar la entrada de los productos adquiridos en el extranjero.",
  "tooltipDataCarregamento": "Fecha en la que está previsto el cargamento del proceso o este ya ha sido realizado.",
  "tooltipExecucaoCarregamento": "Fecha en la que el contenedor fue retirado del puerto.",
  "tooltipCarregamentoAgendado": "Programación del momento en que las mercancías serán cargadas al vehículo y retiradas del puerto. No sé si existe esta fecha en Trinity.",
  "tooltipFechamentoOperacional": "Conclusión de las operaciones logísticas y administrativas relacionadas con la importación.",
  "tooltipDataFaturamento": "Emisión de la factura electrónica, detallando la descripción de las mercancías, cantidades, precios, condiciones de pago, entre otros.",
  "tooltipEnvioFaturamento": "Fecha en que la factura electrónica fue enviada a través del sistema",
  ForgotPassword: 'Olvide mi contraseña',
  consultarProcessos: "Consultar procesos",
  realizarCotacao: "Realizar una cotización",
  documentosGerais: "Documentos generales",
  fretes: "Fletes",
  performance: "Rendimiento",
  analiseFrete: "Análisis de flete",
  acuraciaEstoque: "Exactitud del inventario",
  eficaciaGeral: "Eficacia general",
  basicos: "Básicos",
  portuariaVigentes: "Puerto actual",
  tarefasComex: "Tareas de COMEX",
  interno: "Interno",
  armazenamento: "Almacenamiento",
  gerais: 'Generales',
  sugerirTrasnportadora: 'Sugerir transportista',
  responsavelFrete: 'Responsable del flete',
  agenciamentoInternacional: 'Agenciamiento Internacional',
  acuraciaArmazem: 'Efectividad general de las operaciones de almacenamiento',
  operacional: 'operacional',
  deProcesso: 'del Proceso',
  esteEMais: 'This and more',
  processosForamEncerrados: 'processes were closed',
  esteProcessoEncerrado: 'EEste proceso ha sido cerrado.',
};
